import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getInvoiceState } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { InvoiceDetailsPageContext } from "@insite/content-library/Pages/InvoiceDetailsPage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import Icon from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ShareEntityButton, { ShareEntityButtonStyles } from "@tCooneyBrothers/Overrides/Components/ShareEntityButton";
import Printer from "@insite/mobius/Icons/Printer";
import * as React from "react";
import { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import InvoiceHistoryPrintComponent from "@tCooneyBrothers/Components/InvoiceHistoryPrintComponent";

const enum fields {
    buttonsOrder = "buttonsOrder",
    generateEmailAttachmentFromWebpage = "generateEmailAttachmentFromWebpage",
}

const enum buttons {
    print = "Print",
    email = "Email",
}

interface ButtonMapper {
    [key: string]: {
        button: any;
        showButtonOnTablet?: boolean;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.buttonsOrder]: ButtonModel[];
        [fields.generateEmailAttachmentFromWebpage]?: boolean;
    };
}

interface ButtonModel {
    fields: {
        name: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const invoice = getInvoiceState(state, state.pages.invoiceDetails.invoiceNumber).value;
    const settingsCollection = getSettingsCollection(state);
    return {
        invoice,
        session: state.context.session,
    };
};

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface InvoiceDetailsButtonSetStyles {
    linkLabel: InjectableCss;
    link?: LinkPresentationProps;
    buttonsWrapper?: InjectableCss;
    shareEntityButtonStyles?: ShareEntityButtonStyles;
    printButton?: ButtonPresentationProps;
    spinner?: LoadingSpinnerProps;
    buttonWrapper?: InjectableCss;
    invoiceDetailsComponent?: InjectableCss;
}

export const invoiceDetailsButtonSetStyles: InvoiceDetailsButtonSetStyles = {
    buttonsWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            clear: both;
        `,
    },
    shareEntityButtonStyles: {
        button: {
            variant: "tertiary",
            css: css`
                color: #3674ca;
                border: solid red 7px;
            `,
        },
    },

    printButton: {
        variant: "tertiary",
    },

    spinner: {
        size: 22,
        css: css`
            margin: 8px 50px 0 34px;
        `,
    },

    link: {
        css: css`
            background: #f8f8f8;
            padding: 5px 8px;
            margin-left: 10px;
            svg {
                color: #3674ca;
            }
            > span[class^="TypographyStyle"] {
                display: flex;
            }

            &:hover {
                background: #ebebeb;
            }
        `,
    },
    linkLabel: {
        css: css`
            margin-top: 1px;
            margin-left: 5px;
        `,
    },
    invoiceDetailsComponent: {
        css: css`
            display: none;
        `,
    },
};

/**
 * @deprecated Use orderDetailsButtonSetStyles instead.
 */

export const emailButtonStyles = invoiceDetailsButtonSetStyles;
const styles = invoiceDetailsButtonSetStyles;

const InvoiceDetailsButtonSet: React.FC<Props> = ({ fields, session }) => {
    const { value: invoice } = useContext(InvoiceStateContext);
    const toasterContext = React.useContext(ToasterContext);
    const resolvedGenerateEmailAttachmentFromWebpage =
        fields.generateEmailAttachmentFromWebpage === true || fields.generateEmailAttachmentFromWebpage === undefined;
    if (!invoice) {
        return null;
    }

    const printRef = React.useRef<HTMLDivElement>(null);

    const onClickPrint = () => {
        if (!invoice) {
            return;
        }
        const dataview = printRef?.current?.innerHTML;
        const printBtn = document.getElementsByTagName("iframe")[0].contentWindow;
        printBtn?.document.open();
        printBtn?.document.write(
            `<head> <style>
            .container{
                margin: 5px;
            }
            .invoiceContainer {
                width: 100%;
                margin: 0 auto;
                display: flex;
            }
            .invoiceContainer GridOffset-sc{
               border: solid red 5px;
            }
                .invoiceLogo{
                        max-width: 60%;
                        flex-basis: 60%;
                }
                .invoiceLogo  img{
                    width: 130%;
                    height: auto;
                }

                .invoicelogoGridFirst{
                    margin-top: 20px;
                    max-width: 75%;
                    flex-basis: 75%;
                }
                .invoicelogoGridSecond {
                        max-width: 30%;
                        flex-basis: 30%;
                }
                .invoiceWrapper {
                        width: 100%;
                        display: flex;
                        border: solid black 2px;
                        flex-direction: row;
                }
                .invoiceDate {
                        flex-basis: 50%;
                         max-width: 50%;
                        display: grid;
                        font-size: 16px;
                        border-right: solid black 2px;
                }
                .invoiceDate p{
                    margin: 0;
                    font-weight: bold;
                    text-transform: uppercase;
                }
                .invoiceNumber {
                        flex-basis: 50%;
                        max-width: 50%;
                        display: grid;
                        font-size: 16px;
                }
                .invoiceNumber p{
                    font-weight: bold;
                    margin: 0;
                }
                .invoiceDateInfoGridItem .invoiceText{
                    font-size: 24px;
                    font-weight: bold;
                    text-align: center;
                    text-transform: uppercase;
                }
                .invoiceInfoWrapperFirstRow {
                    width: 100%;
                    display: flex;
                    background: #b4b0b0;
                    border: solid black 3px;
                }
                .invoiceThirdLineItemTable {
                    height: 500px;
                    border: solid;
                    @media print {
                        height: 300px !important;
                    }
                }
                .invoiceTableSecondRow {
                    width: 100%;
                    display: flex;
                    border: solid black 3px;
                    border-top: none;
                }
                .invoiceDateData p{
                    align-items: center;
                }
                .invoiceDateData {
                    border-right: solid black 2px;
                    display: grid;
                    font-size: 16px;
                    flex-basis: 50%;
                    max-width: 50%;
                }
                .invoiceNumberData p{
                    align-items: center;
                }
                .invoiceNumberData {
                    display: grid;
                    font-size: 16px;
                    flex-basis: 50%;
                    max-width: 50%;
                }
                .invoiceDateInfoGridItem {
                        text-align: center;
                        display: grid;
                        margin-top: 30px;
                }
        
                .billingShippingConatiner {
                    margin-top: 20px;
                    display: flex;
                }
                .billingAddressGridItem {
                    margin-left: 10%;
                    flex-basis: 50%;
                    max-width: 50%;
                    justify-content: center;
                }
                .billingAddressGridItem h2{
                  margin: 0;
                }
                .billingAddressGridItem p{
                   margin: 0;
                }
                .billingAddressGridItem address{
                    font-style: inherit;
                 }
            
                .shippingAddressGridItem {
                    margin-left: 10%;
                    flex-basis: 50%;
                    max-width: 50%;
                    justify-content: center;
                }
                .shippingAddressGridItem h2{
                    margin: 0;
                }
                .shippingAddressGridItem p{
                   margin: 0;
                }
                .shippingAddressGridItem address{
                    font-style: inherit;
                 }
            
                .customerInfoWrapperFirstRow {
                        width: 100%;
                        display: flex;
                        background: #b4b0b0;
                        border: solid black 2px;
                        font-weight: bold;
                }
                .customerInfoWrapperFirstRowFirstTable {
                    font-weight: bold;
                    padding: 5px 0 5px 0;
                    width: 100%;
                    display: flex;
                    background: #b4b0b0;
                    border: solid black 2px;
               
                }
                .customerInfoWrapperFirstRowSecondTable {
                    font-weight: bold;
                    width: 100%;
                    display: flex;
                    background: #b4b0b0;
                    border: solid black 2px;
                    padding: 5px 0 5px 0;
                }
               
                .customerInfoWrapperSecondrRow {
                        width: 100%;
                        display: flex;
                        padding: 0;
                        border: solid blacke 2px;
                        padding-top: 5px;
                        padding-bottom: 15px;
                }
                .customerInfoWrapperSecondrRowThirdTable {
                        width: 100%;
                        height: 250px;
                        display: flex;
                        border: solid black 2px;
                }
                .customerInfoGridItem {
                        margin-top: 10px;
                        display: grid;   
                }
                .customerInfoGridItemThirdTable {
                        display: grid;
                        padding: 0;
                }

                .customerNumberGridItem {
                    width: 20%;
                        display: grid;
                        text-align: center;
                }
                .customerOrderNumberGridItem {
                    width: 20%;
                        display: grid;
                        text-align: center;
                }
                .orderByGridItem {
                    width: 20%;
                        display: grid;
                        text-align: center;

                }
                .releaseNumberGridItem {
                    width: 20%;
                        display: grid;
                        text-align: center;
                }
                .salespersonGridItem {
                    width: 20%;
                        display: grid;
                        text-align: center; 
                }
            .writerGridItem{
                        width: 20%;
                        text-align: center; 
                        text-transform: uppercase;
                }
                .shipViaNumberGridItem {
                        width: 20%;
                        display: grid;
                        text-align: center; 
                }
                .termsGridItem {
                    width: 20%;
                        text-align: center;
                        text-transform: uppercase; 
                }
                .shipDateGridItem {
                        width: 20%;
                        text-align: center; 
                        text-transform: uppercase;
                        padding-right: 15px; 
                }
                .orderDateGridItem {
                    width: 20%;
                        text-align: center; 
                        text-transform: uppercase;
                }
                .orderDateGridItemValue{
                    text-align: center;
                }
            .shipDateGridItemValue{
                        width: 20%;
                        display: grid;
                        text-align: center;
                        padding-left: 30px;
            }
                .descriptionGridItem {
                            width: 60%;
                           display: grid;
                           border-right: solid black 2px;
                           max-width: 60% !important;
                           flex-basis: 60% !important;
                           padding: 5px;
                           display: initial;
                           text-transform: uppercase;
                   }
                .qtyOrderedGridItem {
                    width: 10%;
                        display: grid;
                        border-right: solid black 2px;
                        padding: 5px;
                }
                .qtyShippedrGridItem {
                    width: 10%;
                        display: grid;
                        border-right: solid black 2px;
                        padding: 5px;
                }
                .priceGridItem {
                    width: 10%;
                        display: grid;
                        border-right: solid black 2px;
                        padding: 5px;
                }
                .extPriceGridItem {
                    width: 10%;
                        display: grid;
                        padding: 5px;
                }
                .signatureWrapper {
                    width: 40%;
                    display: flex;
                    align-items: center;
                    margin-bottom: 5px;
                    padding: 10px;
                    padding-left: 0;
                    background: #f8f9fa;
                    span {
                        padding-left: 5px;
                    }
            }
            .signatureWrapper  h2{
                width: 200%;
            }
            .signatureContainer {
                margin-top: 15%;
            }
            .signatureText{
                    font-size: 20px;
                    font-weight: bold;
                    width: 100%;
            }
            .totalContainer {
                width: 20%;
                height: auto;
                border: solid black 3px;
                padding: 10px;
                display: flex;
            }
                .invoice-footer-tax-container{
                    width: 300px;
                    text-transform: uppercase;
                }
                .invoice-footer-tax-column{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                }
                .invoice-footer-tax-column h5{
                    margin: 0px;
                    font-size: 12px;
                    text-align: right;
                }
                .invoice-footer-tax-column p{
                    margin: 0px;
                    font-size: 15px;
                    flex-basis: 70px;
                    text-align: right;
                }
            
            .totalLabelText { 
                weight: "bold";
             }
            .totalValueText {
                font-weight: bold;
                margin-left: auto;
              
            }
            .alignSignature {
                    text-align: right;
                    width: 100%;
                    margin-left: auto;
              
            }
            .signatureWrapperTotal {
                    margin-top: 10px;
                    background: #ededed;
                    padding: 20px;
            }
            .messageWrapper {
               width: 75%;
            }
            .messageGridItem {
                max-width: 75%;
                display: grid;
            }
            
            .msgTotalWrapper {
                display: flex;
                margin-top: 30px; 
            }
            .msgText1 {
                padding-top: 30px;
            }
            .msgText2 {
                padding-top: 30px;
                font-size: 19px;
                font-weight: bold;
            
            }
                .item-mfg-Grid{
                    display: flex;
                }
                .item{
                    width: 50%;
                }
                .mfg{
                    width: 50%;
                }
                .desc{
                    margin-bottom: 7px;
                }

            //summary table
                    @media print{
                .invoice-line-shipped,   .invoice-line-unitprice, .invoice-line-extended {
                    background-color: #000000;
                    -webkit-print-color-adjust: exact;
                    padding: 2px;
                    text-transform: uppercase;
                    font-weight: 20px;

                    .invoice-line-table{
                        border-collapse: collapse;
                        border: solid;
                        width: 200%;
                        padding: 50px;
                    }

                    .dataTable {
                        width: 60%;
                    }

                    .dataTableRow {
                        text-align: center;
                    }

                    .invoice-line-table thead{
                        border: solid;
                    }
                }

            .invoice-line-item{
                width: 15%;
                font-size: 12px;
                text-align: left;
            }
            .invoice-line-shipped{
                width: 5%;
                font-size: 12px;
                text-align: center;
            }
            .invoice-line-unitprice{
                width: 15%;
                font-size: 12px;
               text-align: center;
            }
            .invoice-line-extended{
                width: 18%;
                font-size: 12px;
               text-align: right;
            }
        
            .tableWrapper {
                    margin-top: 20px;
            
            }
                </style>`,
                );
                printBtn?.document.write("<body>");
                printBtn?.document.write(dataview!);
                printBtn?.document.write("</body></head>");
                printBtn?.document.close();
                printBtn?.focus();
                printBtn?.print();
    };

    const StyledSpan = getStyledWrapper("span");
    const buttonList: ButtonMapper = {};

    buttonList[buttons.email] = {
        button: (
            <ShareEntityButton
                entityId={invoice.invoiceNumber}
                entityName="Invoice"
                extendedStyles={styles.shareEntityButtonStyles}
                generateAttachmentFromWebpage={resolvedGenerateEmailAttachmentFromWebpage}
                email={session?.email}
            />
        ),
    };

    buttonList[buttons.print] = {
        button: (
            <Link {...styles.link} onClick={onClickPrint} data-test-selector="orderSharePrint">
                <Icon size={18} src={Printer} />
                <StyledSpan {...styles.linkLabel}>{translate("Print")}</StyledSpan>
            </Link>
        ),
    };

    const buttonsToRender = fields.buttonsOrder.map(button => buttonList[button.fields.name]).filter(button => button);

    return (
        <StyledWrapper>
            <StyledWrapper {...styles.buttonsWrapper}>
                {buttonsToRender.map((button, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <StyledWrapper {...styles.buttonWrapper} key={index}>
                        {button.button}
                    </StyledWrapper>
                ))}
            </StyledWrapper>
            <iframe style={{ height: "10px", width: "10px", position: "absolute", display: "none" }}>
                <StyledWrapper {...styles.invoiceDetailsComponent} ref={printRef}>
                    <InvoiceHistoryPrintComponent language={null} enableVat={false} printRef={printRef} />
                </StyledWrapper>
            </iframe>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(InvoiceDetailsButtonSet)),
    definition: {
        allowedContexts: [InvoiceDetailsPageContext],
        displayName: "Invoice  Details Button Set",
        group: "Invoice Details",
        fieldDefinitions: [
            {
                name: fields.buttonsOrder,
                displayName: "Buttons Order",
                editorTemplate: "ListField",
                defaultValue: [{ fields: { name: buttons.email } }, { fields: { name: buttons.print } }],
                getDisplay: (item: HasFields) => {
                    return item.fields.name;
                },
                hideAdd: true,
                hideEdit: true,
                hideDelete: true,
                fieldType: "General",
                sortOrder: 1,
                fieldDefinitions: [
                    {
                        name: "name",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.generateEmailAttachmentFromWebpage,
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                tooltip:
                    "If checked, sharing the Invoice generates an email attachment using the Invoice Details page, rather than a pre-defined PDF file.",
            },
        ],
    },
};

export default widgetModule;
